export enum QuicklisterEndpoint {
  DashboardAlerts = 'alerts',
  SaleListings = 'sale-listings',
  LotListings = 'lot-listings',
  Communities = 'communities',
  Plans = 'plans',
  SaleListingRequests = 'sale-requests',
  LotListingRequests = 'lot-requests',
  Reports = 'reports',
  ReleaseNotes = 'release-notes',
  BillingReport = 'billing-report',
  HomesIQ = 'homes-iq',
  TexasIndex = 'homes-iq/texas-index',
  WeeklyCharts = 'homes-iq/weekly-charts'
}
